export interface Project {
  id: string
  workfrontProjectId: string
  name: string //'QA UHUB 30 Jan 1',
  status: string
  initiativeDescription: string // null,
  briefType: string //'Non WPP',
  brand: string[] //[Array],
  globalCategory: string[]
  targetInMarketDate: string //'2025-03-03',
  workfrontId: string
  interestedActivatingOus: string[]
  operatingUnit: string
  regionalOperatingUnit: string
  aouMarkets: string[]
  aspouMarkets: string[]
  eouMarkets: string[]
  gcpouMarkets: string[]
  emeouMarkets: string[]
  jkouMarkets: string[]
  inswaouMarkets: string[]
  laouMarkets: string[]
  naouMarkets: string[]
  marketsSelected: string[]
  projectSelection: { objCode: string; name: string; ID: string }
  linkedProject: string
  experienceId: string //null,
  briefActionStatus: string //null,
  sendToAgency: boolean
  briefDocumentLocation: string
  projectLead: IColliderUhubUser
  sentToUhub: boolean
  version: number
  uhubResponse: any
  assignedAgencies: string[]
  expectedDueDate: string
  executions: string[]
  anticipatedTouchpoints: string[]
  budgetYear: string
  budgetCurrency?: string
  budget?: number
  documentUrls: string[]
  billingEntity?: string
  updatedAt?: string
  createdAt?: string
  POTags?: string[]
  uhubStatus?: string // uhub phase
  uhubProjectStatus?: string // uhub status
  uhubAssignee?: string
  uhubLead?: string
  uhubLastSync?: string
  syncStatus?: SyncStatus // playground status
  lastSyncVersion: number
  maxVersion: number
  maxBriefVersion: number
  syncedBriefVersion: number
  syncedVersion: number
  referenceNumber: number
  lastBriefSyncVersion: number
}

export interface BriefDocument {
  id: string
  name: string
  documentId: string
  key: string
  lastVersion: string
}

export interface IColliderUhubUser {
  id: string
  country: string
  emailAddr: string
  name: string
}

export interface IUhubErrorResponse {
  errorMessages?: string[]
  errors: Record<string, string>
}

export interface IUhubSuccessResponse {
  id: string
  key: string
  self: string
}

export interface BriefDocument {
  id: string
  name: string
  key: string
  version: string
  description?: string
  url?: string
  briefId: string
}

export interface Brief {
  id: string
  name: string
  VISChange: string
  brandRole: string
  executions: null
  whatIsTheSMIT: string
  targetAudience: string
  briefBusinessProblem: string
  measurementOfSuccess: string
  expectedDueDateBriefs: string
  anticipatedTouchpoints: null
  specificationsForExecution: null
  constraintsAndConsiderations: string
  briefSubmitter: string
  referenceNumber: number
  briefType: string
  version: number
  workfrontProjectId: string
  documents?: BriefDocument[]
}

export interface ProjectDetailed {
  id: string
  workfrontProjectId: string
  name: string
  size: string
  brand: string[]
  POTags: string[]
  budget: string
  status: string
  product?: string
  poOrigin?: string
  briefType: string
  budgetYear?: string
  description?: string
  projectLead?: IColliderUhubUser
  workfrontId: string
  experienceId: string
  projectLevel: string
  brandTradeMark: string
  budgetCurrency?: string
  globalCategory: string[]
  projectSponsor: string
  marketsSelected: string[]
  persistentPlatform: string
  targetInMarketDate: string
  expectedDueDate: string
  leadingParticipating: string
  initiativeDescription: string
  regionalOperatingUnit: string
  operatingUnit: string
  version: number
  sender: string
  briefs: { version: number; documents: BriefDocument[]; expectedDueDateBriefs: string }[]
  lastSyncVersion: number
  lastBriefSyncVersion: number
  syncedVersion: number
  syncStatus: SyncStatus
  syncedBriefVersion: number
  expectedBriefDate: string
}

export enum SyncStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  SYNCED = 'SYNCED',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  SYNCING = 'SYNCING',
  WARNING = 'WARNING',
  REJECTED = 'REJECTED',
  BRIEF_PENDING = 'BRIEF_PENDING',
}

export enum SyncAction {
  REJECT = 'REJECT',
  ACCEPT = 'ACCEPT',
}

export interface StatusMessage {
  status: string
  details: string
}
